import React from 'react';
import { StyleSheet } from 'react-native';

import { Box, Image } from '@/components/lib/components';
import { isWeb } from '@/utils/constants-platform-specific';

const TRUSTLY_PAYMENT_MARK_LOGO_URL = 'https://trustly.one/start/asset/markbetr_190x26_dark@4x.png?UseCase=TrustlyID';

const styles = StyleSheet.create({
    trustlyPaymentMark: {
        width: isWeb ? 190 : '100%',
        height: isWeb ? 26 : '100%',
    },
});

// For Trustly certification purposes, use the image link that is provided by Trustly
export const TrustlyBrandingLogos = () => (
    // On mobile, setting width to 90% to ensure proper alignment with the title and description
    <Box
        alignSelf={isWeb ? 'flex-start' : undefined}
        width={isWeb ? undefined : '90%'}
        height={isWeb ? undefined : 36}
        marginTop="s14"
    >
        <Image
            source={{
                uri: TRUSTLY_PAYMENT_MARK_LOGO_URL + '&v=' + new Date(), // &v= for cache ignore
            }}
            style={styles.trustlyPaymentMark}
            resizeMode="contain"
        />
    </Box>
);
